import styled from "@emotion/styled";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import React from "react";

interface TooltipForTableProps {
  label: string;
}
const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 1000,
  },
});

const TooltipForTable = ({ label }: TooltipForTableProps) => {
  return (
    <CustomWidthTooltip title={label} arrow placement="bottom-start">
      <p className="text-neutral-90 font-normal common-text-ellipse-style">
        {label || "-"}
      </p>
    </CustomWidthTooltip>
  );
};

export default TooltipForTable;
